import { Injectable, inject } from '@angular/core';

import { HttpClientPort, HttpQuery } from '../../core/http/http-client.port';
import { Page } from '../../domain/entities/page';
import { ResourceQuery, TourismResource } from '../../domain/entities/tourism-resource';
import { TourismResourceRepository } from '../../domain/repositories/tourism-resource.repository';
import { toApiLanguage } from '../http/api-language';
import { BOLDEST_ENDPOINTS } from '../http/boldest-endpoints';
import { toPage } from '../mappers/page.mapper';
import { toTourismResource } from '../mappers/tourism-resource.mapper';

const PAGE_LIMIT = 100;

@Injectable()
export class HttpTourismResourceRepository extends TourismResourceRepository {
  private readonly http = inject(HttpClientPort);

  async findAll(query: ResourceQuery): Promise<readonly TourismResource[]> {
    const first = await this.findPage(query, 1);
    const remaining = Array.from({ length: first.meta.totalPages - 1 }, (_, index) => index + 2);
    const rest = await Promise.all(remaining.map((page) => this.findPage(query, page)));

    return [first, ...rest].flatMap((page) => page.items);
  }

  private async findPage(query: ResourceQuery, page: number): Promise<Page<TourismResource>> {
    const payload = await this.http.get({
      path: BOLDEST_ENDPOINTS.resources,
      query: { ...this.toHttpQuery(query), page, limit: PAGE_LIMIT },
    });

    return toPage(payload, toTourismResource, 'resources');
  }

  private toHttpQuery(query: ResourceQuery): HttpQuery {
    return {
      type: query.type,
      category: query.category,
      lang: query.language === undefined ? undefined : toApiLanguage(query.language),
      updated_since: query.updatedSince?.toISOString(),
    };
  }
}
